import { render, staticRenderFns } from "./admin-typeform.vue?vue&type=template&id=aebe6520&scoped=true&"
import script from "./admin-typeform.vue?vue&type=script&lang=js&"
export * from "./admin-typeform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebe6520",
  null
  
)

export default component.exports